import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

import PageNotFound from "./PageNotFound";

type ConditionalFeatureProps = {
  isAllowed: boolean;
  altMessage?: string;
  children: ReactNode;
};

export default function ConditionalFeature({
  isAllowed,
  altMessage,
  children
}: ConditionalFeatureProps) {
  if (!isAllowed) {
    if (!altMessage) {
      return <PageNotFound />;
    }

    return (
      <Stack display="flex" alignItems="center" justifyContent="center">
        <Stack spacing={8} marginTop="25vh">
          <Typography variant="h5" textAlign="center">
            {altMessage}
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return <>{children}</>;
}
